var map = {
	"./aberto.png": 1889,
	"./cintura.png": 4744,
	"./normal.png": 8695,
	"./pensativo.png": 4593,
	"./pensativo2.png": 6599,
	"./um.png": 9396,
	"./unhas.png": 535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7431;